<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @if (!token) {
      <div class="rounded-md border border-wax/40 bg-panel p-9 text-center">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Missing link</span
        >
        <h1 class="font-display text-2xl font-semibold text-parchment">
          That reset link looks incomplete
        </h1>
        <p class="mt-3 text-dusk">
          Request a fresh reset link and click through from the email this time.
        </p>
        <a
          routerLink="/forgot-password"
          class="mt-7 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px"
          >Request a Reset Link</a
        >
      </div>
    } @else if (!submitted()) {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Almost done</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Choose a new password</h1>
      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
      >
        <div class="flex flex-col gap-2">
          <label for="newPassword" class="text-sm font-medium text-parchment">New password</label>
          <app-password-field>
            <input
              id="newPassword"
              appPasswordInput
              formControlName="newPassword"
              autocomplete="new-password"
              class="w-full rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none pr-11"
              placeholder="At least 8 characters"
            />
          </app-password-field>
          @if (form.controls.newPassword.invalid && form.controls.newPassword.touched) {
            <p class="text-sm text-wax-bright">
              8–72 characters, with at least one letter and one number.
            </p>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="confirmPassword" class="text-sm font-medium text-parchment"
            >Confirm password</label
          >
          <app-password-field>
            <input
              id="confirmPassword"
              appPasswordInput
              formControlName="confirmPassword"
              autocomplete="new-password"
              class="w-full rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none pr-11"
            />
          </app-password-field>
          @if (form.errors?.['mismatch'] && form.controls.confirmPassword.touched) {
            <p class="text-sm text-wax-bright">Passwords don't match.</p>
          }
        </div>

        @if (errorMessage()) {
          <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
            {{ errorMessage() }}
          </p>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ submitting() ? 'Saving…' : 'Save New Password' }}
        </button>
      </form>
    } @else {
      <div class="rounded-md border border-gold-dim bg-panel p-9 text-center">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >All set</span
        >
        <h1 class="font-display text-2xl font-semibold text-parchment">Password updated</h1>
        <p class="mt-3 text-dusk">
          You've been logged out everywhere for safety. Log in with your new password.
        </p>
        <a
          routerLink="/login"
          class="mt-7 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px"
          >Go to Log In</a
        >
      </div>
    }
  </div>
</section>
